import { redirect } from "react-router-dom";

export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const anvioGamesData = {
  anvioGamesData: {
    slide1: {
      Zhandu: {
        name: "Zhandu",
        providerName: "Anvio",
        imgUrl: "./images/anvio-games/Zhandu.webp",
        redirectUrl: "/casino/anvioanvio-zhandu",
      },
      Teenpatti: {
        name: "Teenpatti",
        providerName: "Anvio",
        imgUrl: "./images/anvio-games/teenpatti.webp",
        redirectUrl: "/casino/anvioanvio-teenpatti",
      },
      DragonTiger: {
        name: "Dragon Tiger",
        providerName: "Anvio",
        imgUrl: "./images/anvio-games/dragontiger.webp",
        redirectUrl: "/casino/anvioanvio-dragon-tiger",
      },
      Dana: {
        name: "Dana",
        providerName: "Anvio",
        imgUrl: "./images/anvio-games/dana.webp",
        redirectUrl: "/casino/anvioanvio-dana",
      },
      Roulette: {
        name: "Roulette",
        providerName: "Anvio",
        imgUrl: "./images/anvio-games/Roulette.webp",
        redirectUrl: "/casino/anvioanvio-roulette",
      },
      SevenUpAndDown: {
        name: "7 Up & Down",
        providerName: "Anvio",
        imgUrl: "./images/anvio-games/sevenupdown.webp",
        redirectUrl: "/casino/anvioanvio-7-up-and-down",
      },
      Teenpatti2: {
        name: "Teenpatti 2",
        providerName: "Anvio",
        imgUrl: "./images/anvio-games/Teenpatti2.webp",
        redirectUrl: "/casino/anvioanvio-teenpatti2",
      },
    },
    name: "Anvio Games",
    key: "AnvioGames",
  },
};
